import React, { useCallback, useEffect } from "react";
import ReactFlow, {
  addEdge,
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
} from "react-flow-renderer";
import units from "../data/units.json";

import { nodes as initialNodes, edges as initialEdges } from "./initial-elements";
import { useToast } from "@chakra-ui/react";

const onInit = (reactFlowInstance) => console.log("flow loaded:", reactFlowInstance);

const Flow = ({ coursemapUnits, setSelectedUnit }) => {
  const [nodes, setNodes, onNodesChange] = useNodesState(initialNodes);
  console.log(nodes);
  const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);
  const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), []);

  const toast = useToast();

  useEffect(() => {
    const inputtedUnits = coursemapUnits.filter((unit) => unit != "");
    setNodes((nds) =>
      nds.map((node, idx) => {
        if (inputtedUnits.includes(node.data.label)) {
          node.style = { ...node.style, backgroundColor: "#98ff98" };
          node.selected = true;
          console.log(node);
        } else {
          console.log(node);
          if (node.unit_type == "core") {
            node.style = {
              ...node.style,
              backgroundColor: "#FFFF00",
              fontSize: "35px",
              fontWeight: "bold",
              width: "200px",
              height: "70px",
            };
          } else {
            node.style = {
              ...node.style,
              backgroundColor: "#EBECF0",
              fontSize: "30px",
              fontWeight: "bold",
              width: "200px",
              height: "70px",
            };
          }
        }
        return node;
      }),
    );
  }, [coursemapUnits]);

  return (
    <ReactFlow
      nodes={nodes}
      edges={edges}
      onNodesChange={onNodesChange}
      onEdgesChange={onEdgesChange}
      onConnect={onConnect}
      onInit={onInit}
      fitView
      attributionPosition="top-right"
      onClick={(e) => {
        const unit_code = e.target.innerText;
        if (unit_code != "" && unit_code.length <= 7) {
          units.forEach((unit) => (unit.unit_code == unit_code ? setSelectedUnit(unit) : null));
          navigator.clipboard.writeText(e.target.innerText);

          return toast({
            title: `${unit_code} copied to clipboard!`,
            description: "Double click desired coursemap slot to paste unit code :)",
            status: "info",
            duration: 5000,
            isClosable: true,
          });
        }
      }}
    >
      <Background color="#aaa" gap={16} />
    </ReactFlow>
  );
};

export default Flow;
